import React, { useState } from "react";
import { Container, Row, Col, Alert, Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Particle from "../Particle";

function AccountDeletion() {
  const navigate = useNavigate();
  const [redirecting, setRedirecting] = useState(false);
  
  const GOOGLE_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSc292h7foTJw8FHrGeRdcR06H0dpu47HruRe1eX67plqkzpnQ/viewform?usp=dialog"; // Replace with your Google Form URL
  
  const handleRedirect = () => {
    setRedirecting(true);
    // Redirect to Google Form
    window.location.href = GOOGLE_FORM_URL;
  };
  
  return (
    <Container fluid className="about-section position-relative" style={{ background: "linear-gradient(180deg, #121212 0%, #1a1a1a 100%)" }}>
      <div style={{ position: "absolute", width: "100%", height: "100%", top: 0, left: 0 }}>
        <Particle />
      </div>
      <Container style={{ paddingTop: "120px", paddingBottom: "120px", position: "relative", zIndex: 5 }}>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <div 
              style={{
                background: "rgba(255, 255, 255, 0.05)",
                borderRadius: "20px",
                padding: "40px",
                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
                position: "relative",
              }}
            >
              <h1 
                style={{
                  fontSize: "2.2em",
                  fontWeight: "700",
                  textAlign: "center",
                  marginBottom: "30px",
                  background: "linear-gradient(90deg, #805AD5 0%, #D53F8C 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Delete Your Account
              </h1>
              
              <Alert variant="warning" className="mb-4">
                <strong>Warning:</strong> Account deletion cannot be undone. All your data will be permanently removed.
              </Alert>
              
              <p className="text-light mb-4">
                To delete your NuroFit account, you'll need to complete a short form to verify your request.
              </p>
              
              <Button
                onClick={handleRedirect}
                disabled={redirecting}
                style={{
                  width: "100%",
                  background: "#DC3545",
                  border: "none",
                  padding: "12px",
                  borderRadius: "10px",
                  fontSize: "1.1em",
                  fontWeight: "600",
                  marginTop: "15px",
                  position: "relative",
                }}
              >
                {redirecting ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Redirecting...
                  </>
                ) : (
                  "Continue to Deletion Form"
                )}
              </Button>
              
              <div className="mt-4 text-center">
                <Button
                  variant="link"
                  onClick={() => navigate("/nurofit")}
                  style={{
                    color: "#b0b0b0",
                    textDecoration: "none",
                    position: "relative",
                  }}
                >
                  Return to NuroFit
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default AccountDeletion;